import * as Sentry from '@sentry/react';
import { DEV, VERSION_HASH } from './constants';

export function initSentry() {
  if (DEV && !process.env.NEXT_PUBLIC_SENTRY_DEV) return;

  Sentry.init({
    dsn: 'https://3931018355f7708da8379b99d3830388@o4508837564383232.ingest.us.sentry.io/4510755034955776',
    environment: DEV ? 'development' : 'production',
    release: VERSION_HASH,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  });
}

export { Sentry };
